import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InfoBlock } from '../styled';
import VideoModal from './VideoModal';

const FooterLinkBlock = ({ title, links }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);

  const LinkIcon = ({ iconUrl }) =>
    iconUrl ? (
      <img
        className="imr-5"
        src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/footer-icons${iconUrl}`}
        alt="icon"
        height={18}
      />
    ) : null;

  const handleClickLink = (url, partner) => {
    window.open(url, '_blank');
  }

  const renderLink = link => {
    const { type, url, text, iconUrl, videoUrl, partner } = link;

    const content = (
      <>
        <LinkIcon iconUrl={iconUrl} />
        {text}
      </>
    );

    switch (type) {
      case 'support':
        return (
          <a href={url} data-toggle="modal" data-target="#notiModalContact">
            {content}
          </a>
        );

      case 'video':
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={() => {
              setCurrentVideoUrl(videoUrl);
              setIsModalOpen(true);
            }}
            href="#">
            {content}
          </a>
        );

      default:
        return (
          <a onClick={() => handleClickLink(url, partner)} target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        );
    }
  };

  return (
    <>
      <InfoBlock>
        <div className="text-title-2">{title}</div>
        <ul>
          {links.map((link, i) => (
            <li key={i}>{renderLink(link)}</li>
          ))}
        </ul>
      </InfoBlock>

      <VideoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        videoUrl={currentVideoUrl}
      />

      {/* <ChatbotModal
        show={openChatbotModal}
        handleClose={() => setOpenChatbotModal(false)}
      /> */}
    </>
  );
};

FooterLinkBlock.propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
      text: PropTypes.string,
      iconUrl: PropTypes.string,
      videoUrl: PropTypes.string
    })
  )
};

export default FooterLinkBlock;
